import React from 'react';
import ScreenManager from './ScreenManager';

function App() {
  return <ScreenManager />;
}

export default App;
